import React, { ReactNode, useEffect } from 'react'

const Modal = ({
  faIcon,
  svgIcon,
  title,
  onClose,
  onBack,
  renderBackButton,
  visiblyHideBackButton,
  children,
}: {
  faIcon?: string
  svgIcon?: ReactNode
  title: string
  onClose: () => void
  onBack?: () => void
  renderBackButton?: boolean
  visiblyHideBackButton?: boolean
  children?: ReactNode
}) => {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [onClose])

  return (
    <div className='modal'>
      <header className='modal__header'>
        {renderBackButton && (
          <button
            className={[
              'modal__header-back-btn',
              visiblyHideBackButton && 'modal__header-back-btn--hidden',
            ].join(' ')}
            onClick={onBack || undefined}
          >
            <i className='fa-solid fa-arrow-left'></i>
          </button>
        )}

        <div className='modal__header-title'>
          {faIcon && <i className={`fa-solid ${faIcon}`}></i>}
          {svgIcon && <>{svgIcon}</>}

          <p>{title}</p>
        </div>

        <button className='modal__header-close-btn' onClick={onClose}>
          <i className='fa-solid fa-close'></i>
        </button>
      </header>

      {children && (
        <div className='modal__scroll-wrapper'>
          <div className='modal__content-wrapper'>{children}</div>
        </div>
      )}
    </div>
  )
}

export { Modal }
